import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  add_designation,
  delete_designation,
  get_designation,
  get_designation_list,
  update_designation,
} from "../Service/ApiServices";
import { toast } from "react-toastify";

const initialState = {
  designations: [],
  designationlist: [],
  school_id:"",
  department_id:"",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    name: "",
  },
};
// Async Thunks for API Calls
export const fetchDesignationList = createAsyncThunk(
  'designation/fetchDesignationlist',
  async ({school_id,department_id,token, signal }, { rejectWithValue }) => {
    try {
      const response = await get_designation_list(school_id,department_id,token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Async Thunks for API Calls
export const fetchDesignation = createAsyncThunk(
  "designation/fetchDesignation",
  async ({ page, page_size,school_id,department_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await get_designation(page, page_size,school_id,department_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createDesignation = createAsyncThunk(
  "designation/createDesignation",
  async ({ data,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_designation(data,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updateDesignation = createAsyncThunk(
  "designation/updateDesignation",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_designation(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteDesignation = createAsyncThunk(
  "designation/deleteDesignation",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_designation({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const designationSlice = createSlice({
  name: "designations",
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(state, action) {
      // The action should contain all the fields that need to be updated
      const { id, name } = action.payload;
      state.formData = { id, name };
    },
    resetFormData(state) {
      state.formData = {
        name: "",
      };
    },
    setDesignation(state,action){
        state.designations = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
    setDepartmentId(state, action) {
      state.department_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
    // section list 
    .addCase(fetchDesignationList.fulfilled, (state, action) => {
      state.designationlist = action.payload.data;
    })
      // Fetch Classes
      .addCase(fetchDesignation.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDesignation.fulfilled, (state, action) => {
        state.loading = false;
        state.designations = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchDesignation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add Class
      .addCase(createDesignation.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createDesignation.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createDesignation.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.IsEditing = false;
      })
      // Update Class
      .addCase(updateDesignation.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateDesignation.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;

        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updateDesignation.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        state.IsEditing = false;

        toast.info(action?.payload?.message || "Something went wrong!");
      })
      // Delete Class
      .addCase(deleteDesignation.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteDesignation.fulfilled, (state, action) => {
        state.loading = false;
        console.log(action.payload);
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deleteDesignation.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");

        state.error = action.payload;
      });
  },
});

export const {
  setDesignation,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize,
  setDepartmentId
} = designationSlice.actions;
export default designationSlice.reducer;
